import Vue from 'vue';
import VueRouter, { Route, RouteConfig } from 'vue-router';
import LoginLayout from '@/layout/login/index.vue';
import MainLayout from '@/layout/main/index.vue';
import { UserModule } from '@/store/modules/user';
import { PermissionModule } from '@/store/modules/permission';

Vue.use(VueRouter);

export const constantRoutes: Array<RouteConfig> = [
  {
    path: '/login',
    component: LoginLayout,
    meta: {
      hidden: true,
    },
    children: [
      {
        path: '',
        name: 'Login',
        component: () => import('@/views/login/login.vue'),
        meta: {
          hidden: true,
        },
      },
      {
        path: '/business/join',
        name: 'BusinessJoin',
        component: () => import('@/views/login/join.vue'),
        meta: {
          hidden: true,
        },
      },
      {
        path: '/business/find',
        name: 'BusinessFind',
        component: () => import('@/views/login/find.vue'),
        meta: {
          hidden: true,
        },
      },
    ],
  },
  {
    path: '/',
    name: 'Index',
    redirect: '/business',
    component: MainLayout,
    meta: {
      hidden: true,
    },
    children: [
      {
        path: 'business',
        name: 'Business',
        component: () => import('@/views/business/index.vue'),
        meta: {
          name: '사업자 정보',
        },
      },
      {
        path: 'business/store',
        name: 'BusinessStore',
        component: () => import('@/views/business/store.vue'),
        meta: {
          name: '관광지 관리',
        },
      },
      {
        path: 'community',
        name: 'FAQ',
        component: () => import('@/views/community/faq.vue'),
        meta: {
          name: 'faq',
        },
      },
      {
        path: 'community/one-inquiry',
        name: 'one-on-oneInquiry',
        component: () => import('@/views/community/one-on-one/index.vue'),
        meta: {
          name: 'one-on-oneinquiry',
        },
      },
      {
        path: 'community/one-inquiry/write',
        name: 'one-inquiryWrite',
        component: () => import('@/views/community/one-on-one/write.vue'),
        meta: {
          name: '문의글쓰기',
        },
      },
      {
        path: 'community/one-inquiry/detail',
        name: 'one-inquiryDetail',
        component: () => import('@/views/community/one-on-one/detail.vue'),
        meta: {
          name: '문의글쓰기',
        },
      },
      {
        path: 'community/staymanual',
        name: 'StayManual',
        component: () => import('@/views/community/staymanual.vue'),
        meta: {
          name: '숙박 사용자메뉴얼',
        },
      },
      {
        path: 'community/leisuremanual',
        name: 'LeisureManual',
        component: () => import('@/views/community/leisuremanual.vue'),
        meta: {
          name: '레저 사용자메뉴얼',
        },
      },
      {
        path: 'community/restaurantmanual',
        name: 'RestaurantManual',
        component: () => import('@/views/community/restaurantmanual.vue'),
        meta: {
          name: '외식 사용자메뉴얼',
        },
      },
      {
        path: 'community/inquiry',
        name: 'Inquiry',
        component: () => import('@/views/community/inquiry/index.vue'),
        meta: {
          name: '문의하기',
        },
      },
      {
        path: 'community/inquiry/:uid',
        name: 'InquiryDetail',
        component: () => import('@/views/community/inquiry/detail.vue'),
        meta: {
          name: '문의하기',
        },
      },
      /*
      {
        path: 'community/inquiry/write',
        name: 'Write',
        component: () => import('@/views/community/write.vue'),
        meta: {
          name: '문의글쓰기',
        },
      },
      {
        path: 'community/inquiry/view',
        name: 'View',
        component: () => import('@/views/community/view.vue'),
        meta: {
          name: '문의글내역',
        },
      },
      */
      {
        path: 'notice',
        name: 'Notice',
        component: () => import('@/views/notice/index.vue'),
        meta: {
          name: '공지사항',
        },
      },
      {
        path: 'calculate',
        name: 'Calculate',
        component: () => import('@/views/calculate/index.vue'),
        meta: {
          name: '정산',
        },
      },
      {
        path: 'stay',
        name: 'Stay',
        component: () => import('@/views/stay/index.vue'),
        meta: {
          name: '숙박시설 관리',
        },
      },
      {
        path: 'stay/room',
        name: 'StayRoom',
        component: () => import('@/views/stay/room/index.vue'),
        meta: {
          name: '객실 관리',
        },
      },
      {
        path: 'stay/room/add',
        name: 'StayRoomAdd',
        component: () => import('@/views/stay/room/form.vue'),
        meta: {
          name: '객실 추가',
          hidden: true,
        },
      },
      {
        path: 'stay/room/:idx/update',
        name: 'StayRoomUpdate',
        component: () => import('@/views/stay/room/form.vue'),
        meta: {
          name: '객실 수정',
          hidden: true,
        },
      },
      {
        path: 'stay/room/price',
        name: 'StayRoomPrice',
        component: () => import('@/views/stay/price/index.vue'),
        meta: {
          name: '요금 관리',
        },
      },
      {
        path: 'stay/room/price/special',
        name: 'StayRoomSpecialPrice',
        component: () => import('@/views/stay/price/special/index.vue'),
        meta: {
          name: '특가 설정',
        },
      },
      {
        path: 'stay/room/price/calendar',
        name: 'StayRoomCalendar',
        component: () => import('@/views/stay/price/calendar.vue'),
        meta: {
          name: '요금 달력',
        },
      },
      {
        path: 'stay/room/season',
        name: 'StayRoomSeason',
        component: () => import('@/views/stay/season/index.vue'),
        meta: {
          name: '성수기 관리',
        },
      },
      {
        path: 'cancel',
        name: 'Cancel',
        component: () => import('@/views/cancel/index.vue'),
        meta: {
          name: '취소/환불 관리',
        },
      },
      {
        path: 'cancel/add',
        name: 'CancelAdd',
        component: () => import('@/views/cancel/form.vue'),
        meta: {
          name: '취소/환불 추가',
          hidden: true,
        },
      },
      {
        path: 'cancel/:idx/update',
        name: 'CancelUpdate',
        component: () => import('@/views/cancel/form.vue'),
        meta: {
          name: '취소/환불 수정',
          hidden: true,
        },
      },
      {
        path: 'reserve/item',
        name: 'ReserveItem',
        component: () => import('@/views/reserve/item/index.vue'),
        meta: {
          name: '상품 관리',
        },
      },
      {
        path: 'reserve/item/add',
        name: 'ReserveItemAdd',
        component: () => import('@/views/reserve/item/form.vue'),
        meta: {
          name: '서비스 추가',
        },
      },
      {
        path: 'reserve/item/update/:uid',
        name: 'ReserveItemUpdate',
        component: () => import('@/views/reserve/item/form.vue'),
        meta: {
          name: '예약 서비스 수정',
        },
      },
      {
        path: 'reserve/client',
        name: 'ReserveClient',
        component: () => import('@/views/reserve/client/index.vue'),
        meta: {
          name: '예약 내역',
        },
      },
      {
        path: 'reserve/client/:uid',
        name: 'ReserveClientDetail',
        component: () => import('@/views/reserve/client/detail.vue'),
        meta: {
          name: '예약 내역',
          hidden: true,
        },
      },
      {
        path: 'reserve/client/:uid/check',
        name: 'ReserveClientCheck',
        component: () => import('@/views/reserve/client/check.vue'),
        meta: {
          name: '예약 확인',
          hidden: true,
        },
      },
      {
        path: 'reserve/calendar',
        name: 'ReserveCalendar',
        component: () => import('@/views/reserve/client/calendar.vue'),
        meta: {
          name: '예약 현황',
        },
      },
      {
        path: 'reserve/stay/calendar/',
        name: 'ReserveStayCalendar',
        component: () => import('@/views/reserve/client/stayCalendar.vue'),
        meta: {
          name: '예약 현황',
        },
      },
      {
        path: 'reserve/add',
        name: 'ReserveAdd',
        component: () => import('@/views/reserve/add/index.vue'),
        meta: {
          name: '신규 예약 등록',
        },
      },
      {
        path: 'room',
        name: 'RoomManagement',
        component: () => import('@/views/room/index.vue'),
        meta: {
          name: '방막기/풀기',
        },
      },
      {
        path: 'tourism',
        name: 'Tourism',
        component: () => import('@/views/tourism/index.vue'),
        meta: {
          name: '관광지 관리',
        },
      },
      {
        path: 'certificate',
        name: 'Certificate',
        component: () => import('@/views/certificate/index.vue'),
        meta: {
          name: '공인인증서 등록',
          hidden: true,
        },
      },
      {
        path: 'event',
        name: 'Event',
        component: () => import('@/views/event/index.vue'),
        meta: {
          name: '이벤트 관리',
        },
      },
      {
        path: 'review',
        name: 'Review',
        component: () => import('@/views/review/index.vue'),
        meta: {
          name: '리뷰 내역',
        },
      },
      /*
      {
        path: 'coupon',
        name: 'Coupon',
        component: () => import('@/views/coupon/index.vue'),
        meta: {
          name: '쿠폰 관리',
        },
      },
      */
    ],
  },
  {
    path: '/nice/accept',
    component: () => import('@/views/nice/accept.vue'),
    name: 'NiceAccept',
    meta: {
      hidden: true,
    },
  },
  {
    path: '/nice/deny',
    component: () => import('@/views/nice/deny.vue'),
    name: 'NiceDeny',
    meta: {
      hidden: true,
    },
  },
];

const createRouter = () => new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: constantRoutes,
});

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  (router as any).matcher = (newRouter as any).matcher; // reset router
}

/*
router.beforeEach((to: Route, from: Route, next: any) => {
  const whiteList = ['Login', 'BusinessJoin', 'NiceAccept', 'NiceDeny'];
  if (whiteList.indexOf(to.name || '') < 0) {
    UserModule.GetUserInfo();
    next();
  } else {
    next();
  }
});
*/

router.afterEach((to: Route, from: Route) => {
  const pageTitle = '남해군 원스톱 관광 플랫폼 관리자';
  document.title = pageTitle;
  const storedRoles = UserModule.roles;
  PermissionModule.GenerateRoutes(storedRoles);
});

export default router;
